import React from 'react';
import { Clock, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';

// status: 'ok' | 'warning' | 'breached' | 'met' | null
const CONFIG = {
  ok:       { color: '#10b981', bg: '#d1fae5', icon: Clock,         label: 'On track'  },
  warning:  { color: '#f59e0b', bg: '#fef3c7', icon: AlertTriangle,  label: 'At risk'   },
  breached: { color: '#ef4444', bg: '#fee2e2', icon: XCircle,        label: 'Breached'  },
  met:      { color: '#6b7280', bg: '#f3f4f6', icon: CheckCircle,    label: 'Met'       },
};

export function SlaBadge({ status, hoursLeft, label, compact = false }) {
  if (!status) return null;
  const cfg = CONFIG[status] || CONFIG.ok;
  const Icon = cfg.icon;

  if (compact) {
    return (
      <span title={label || cfg.label} style={{
        display: 'inline-flex', alignItems: 'center', gap: 3,
        padding: '2px 6px', borderRadius: 4,
        background: cfg.bg, color: cfg.color,
        fontSize: 11, fontWeight: 600,
      }}>
        <Icon size={10} />
        {label || cfg.label}
      </span>
    );
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 6,
      padding: '6px 10px', borderRadius: 6,
      background: cfg.bg, color: cfg.color,
      fontSize: 12, fontWeight: 500,
    }}>
      <Icon size={13} />
      <span>{label || cfg.label}</span>
      {hoursLeft !== undefined && hoursLeft > 0 && (
        <span style={{ opacity: 0.75 }}>
          ({hoursLeft < 1 ? `${Math.round(hoursLeft * 60)}m` : `${hoursLeft.toFixed(1)}h`} left)
        </span>
      )}
    </div>
  );
}

// Full SLA panel for ticket detail sidebar
export function SlaPanel({ sla }) {
  if (!sla || !sla.rule) return null;

  return (
    <div className="sidebar-section">
      <div className="sidebar-section-title">SLA</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>First Response</div>
          <SlaBadge
            status={sla.responseStatus}
            hoursLeft={sla.responseHoursLeft}
            label={sla.responseStatus === 'met' ? 'Responded on time' :
                   sla.responseStatus === 'breached' ? 'Response overdue' :
                   sla.responseStatus === 'warning' ? 'Response due soon' : 'On track'}
          />
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 3 }}>
            Due: {new Date(sla.responseDeadline).toLocaleString()}
          </div>
        </div>
        <div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>Resolution</div>
          <SlaBadge
            status={sla.resolutionStatus}
            hoursLeft={sla.resolutionHoursLeft}
            label={sla.resolutionStatus === 'met' ? 'Resolved on time' :
                   sla.resolutionStatus === 'breached' ? 'Resolution overdue' :
                   sla.resolutionStatus === 'warning' ? 'Resolution due soon' : 'On track'}
          />
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 3 }}>
            Due: {new Date(sla.resolutionDeadline).toLocaleString()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SlaBadge;
